<template>
  <div>Loading...</div>
</template>

<script setup lang="ts"></script>

<style></style>
